import template from "./pCasemanTeamPgConfig.html";

export function pCasemanTeamPgConfigDirective() {
  'ngInject';

  let directive = {
    restrict: 'E',
    template: template,
    controller: pCasemanTeamPgConfigController,
    controllerAs: 'pCasemanTeamPgConfig',
    bindToController: true
  };

  return directive;
}

class pCasemanTeamPgConfigController {
  constructor($scope, $location, $interval, $q, Auth, Caseman, Notes, Sort, ConnectionQuality) {
    'ngInject';
    this.$scope = $scope;
    this.$location = $location;
    this.$interval = $interval;
    this.$q = $q;
    this.Auth = Auth;
    this.Caseman = Caseman;
    this.Notes = Notes;
    this.Sort = Sort;
    this.ConnectionQuality = ConnectionQuality;
    this.state = "loading";

    this.headers = [
      {name: "CASEMAN.PROCESS_GROUP_KLIX", class: "table-info"},
      {name: "CASEMAN.JOBCODE_CASEMAN", class: "table-caseman"},
    ];

    this.Auth.authorize().then(
      (user) => {
        this.user = user;

        //Notes...
        const timeout = this.$interval(() => { this.notes = this.Notes.getNotes();}, 200);
        this.$scope.$on("$destroy", () => {this.$interval.cancel( timeout );});

        let promises = [
          this.Caseman.getCountryProcessGroups(),
          this.Caseman.getCountryInterrupts()
        ];

        this.$q.all(promises).then(
          (success) => {
            this.processGroupsKlix = success[0].data.sort(this.Sort.abcBy("name"));
            this.interruptsKlix = success[1].data.sort(this.Sort.abcBy("name"));

            this.refresh();
          },
          (error) => {
            this.state = "error";
            this.Notes.postNote({type: "error", error: error});
          }
        );
      },
      () => {
        this.Auth.handleUnauthorized();
      }
    );

    $scope.$on('connectionQualityChanged', () => {
      if (this.ConnectionQuality.isSlow) {
        this.Notes.postNote({
          type: 'slowConnection',
          manualHide: true
        });
      }
      else {
        const note = this.Notes.getNotes().find(note => note.type === 'slowConnection' && note.active);
        if (note)
          this.Notes.hide(note);
      }
    });
  }

  refresh() {
    this.Caseman.getCountryProcessGroupsMappers().then(
      (success) => {
        this.mapper = success.data; // interruptCountryConfigurationId, processGroupCountryConfigurationId, processGroupCountryConfigurationName, jobCodeId, jobCodeName, country
        this.processGroupsMapper = this.mapper.filter(mapper => mapper.processGroupCountryConfigurationId && mapper);
        this.interruptsMapper = this.mapper.filter(mapper => mapper.interruptCountryConfigurationId && mapper);

        this.mapperToDisplay = this.processGroupsKlix && this.processGroupsKlix.map( pgKlix => {
          let client = this.processGroupsMapper && this.processGroupsMapper.find(pgMapper => pgMapper.processGroupCountryConfigurationId == pgKlix.id);
          if(!client) {
            client = {processGroupCountryConfigurationId: pgKlix.id , processGroupCountryConfigurationName: pgKlix.name, jobCodeId: null, jobCodeName: null, unmatched: true};
          }
          return client;
        });

        this.interruptMapperToDisplay = this.interruptsKlix && this.interruptsKlix.map( interruptKlix => {
          let client = this.interruptsMapper && this.interruptsMapper.find(interruptMapper => interruptMapper.interruptCountryConfigurationId == interruptKlix.id);
          if(!client) {
            client = {interruptCountryConfigurationId: interruptKlix.id , interruptName: interruptKlix.name, jobCodeId: null, jobCodeName: null, unmatched: true};
          }
          return client;
        });
        this.state = "loaded";
      },
      (error) => {
        this.state = "error";
        this.Notes.postNote({type: "error", error: error});
      }
    );
  }

  back() {
    window.history.back();
  }

  viewProcesses(mapper) {
    this.$location.path('/caseman/config/teamProcessGroups/'+ mapper.processGroupCountryConfigurationId + '/name/' + encodeURIComponent(mapper.processGroupCountryConfigurationName) + '/jobcode/' + mapper.jobCodeId + '/country/' + mapper.country);
  }

}